/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="drawerManager.module.ts" />
/// <reference path="posStationPrompt/posStationPrompt.modal.controller.ts" />

module Meevo.Plugins.DrawerManager {
    "use strict";

    export enum DrawerManagerSectionTypeEnum {
        UnassignedDrawer = 1,
        OpeningDrawer = 2,
        DrawerOpened = 3,
        ClosingDrawer = 4,
        DrawerClosed = 5,
        PayIn = 6,
        PayOut = 7,
        CashCalculator = 8,
        CashTransactions = 9,
        CreditCardListings = 10,
        DrawerHistory = 11,
        TipsCollection = 12
    }

    export interface CreditCardTransactionSelection {
        paymentTypeId: string;
        selectAllItemsChecked: boolean;
        allItemsSelected: boolean;
        transactionSelections: any[];
        selectionTotal: number;
    }

    export class DrawerManagerController {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.common.PrintService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "meevo.components.common.RoundingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',

            "meevo.components.busy.BusyService",
            "$translate",
            "$timeout",
            "$q",
            "$filter",
            "$cookies",
            "meevo.plugins.tippy.tippyService"
        ];

        public context: DrawerManagerContext;
        public insideRegister: boolean = false;
        public registerContext: Meevo.Plugins.Register.RegisterContext;
        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        protected drawerSessionItem;
        okButtonShortCut = 'MODAL_OK_BUTTON';
        private shortCutGroup: IShortCutGroup;

        // Guards against re-prompting more than once per initialize() pass (e.g. the activated station still
        // failing to resolve), which would otherwise loop with no exit except opting out. initialize() is
        // currently only called once (from the constructor), so the reset below is a no-op today, but it's
        // cheap insurance if that ever changes.
        private posStationPromptShownThisPass: boolean = false;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected $q: angular.IQService,
            protected $filter: angular.IFilterService,
            protected $cookies: angular.cookies.ICookiesService,
            protected tippyService: Plugins.Tippy.TippyService
        ) {

            let isDrawerHistory = (this.$state.params.targetState === "DrawerHistory");

	        switch (this.$state.current.name) {
		        case this.appSettings.ROUTE_NAMES.register:
		        case this.appSettings.ROUTE_NAMES.giftCardBalance:
			        this.insideRegister = true;
			        break;
	        }

            this.context = new DrawerManagerContext(
                this,
                this.appSettings,
                this.dataService,
                this.securityService,
                this.modalService,
                this.identityService,
                this.printService,
                this.loggingService,
                this.trackingService,
                this.roundingService,
                this.$translate,
                this.$rootScope,
                this.$scope,
                this.$timeout,
                this.$q,
                this.$filter,
                isDrawerHistory,
                this.$cookies,
                this.insideRegister,
                this.tippyService);

            if (isDrawerHistory) {
                this.initializeDrawerHistory();
                this.context.selectedSection.initialize(this.$state.current.params && this.$state.current.params.id ? this.$state.current.params.id : null);
            }
            else {
                this.initialize();
                this.setupEventHandlers();
            }
            this.shortCutsService.activateGroup(this.shortCutGroup);

            this.$rootScope.$on(Meevo.Components.Common.Messages.CONTEXT_HAS_CLOSED, (event, state) => {
                if (state == "drawerHistory") {
                    this.$rootScope.drawerHistorySearchCriteria = undefined;
                }
            });
        }

        initializeDrawerHistory() {
            this.context.getRegisterSettings();
            this.context.selectSection(DrawerManagerSectionTypeEnum.DrawerHistory);
        }

        private setAssignedDrawer(posAssignedDrawer) {
            return this.context.getDrawerInfo(this.context.drawerPreferences.lastUsedDrawerId).then((data) => {
                let userAssignedDrawer: Meevo.Model.Drawer = data;
                if (userAssignedDrawer) {
                    let message = this.$translate.instant("MESSAGE_POS_ASSIGNED_ANOTHER_DRAWER", {
                        userAssignedDrawerName: (userAssignedDrawer ? userAssignedDrawer.displayName : "Unknown"),
                        posAssignedDrawerName: (posAssignedDrawer ? posAssignedDrawer.displayName : "Unknown")
                    });

                    return this.modalService.confirm(message)
                        .then((response) => {
                            if (response) {
                                this.context.setSelectedDrawer(posAssignedDrawer, false, Meevo.Model.DrawerSelectionReasonEnum.InitialLoad);
                            }
                            else if (this.context.insideRegister) {
                                // do not let them in the Register if the user opted not to use the POS'es drawer
                                this.$rootScope.$broadcast("closeContext", this.$state.current, null);
                            }
                        })
                        .catch(() => {
                            if (this.context.insideRegister) {
                                // do not let them in the Register if the user opted not to use the POS'es drawer
                                this.$rootScope.$broadcast("closeContext", this.$state.current, null);
                            }
                        });
                }
                else {
                    this.context.setSelectedDrawer(posAssignedDrawer, false, Meevo.Model.DrawerSelectionReasonEnum.InitialLoad);
                }
            });
        }

        initialize() {
            this.posStationPromptShownThisPass = false;
            this.context.initialize().then(() => {
                this.resolveInitialSection();
            }).catch(() => {
                // context.initialize() is a $q.all() over several calls (drawer list, payment types, etc) - if any
                // of them fails, fall back to the same "can't resolve a drawer automatically" state used elsewhere
                // in this file, rather than leaving an unhandled rejection with no section selected.
                this.context.selectSection(DrawerManagerSectionTypeEnum.UnassignedDrawer);
            });
        }

        private resolveInitialSection() {
            if (!this.context.allDrawers || this.context.allDrawers.length < 1) {
                return this.context.selectSection(DrawerManagerSectionTypeEnum.UnassignedDrawer);
            }

            // Deleted/no-longer-Active POS Stations are treated the same as no cookie at all, so the
            // POS Station prompt re-appears instead of silently reusing a stale assignment.
            let posStationId = this.context.activePosStationId;
            let lastUsedDrawerId = this.context.drawerPreferences.lastUsedDrawerId;
            let lastUsedDrawer: Meevo.Model.Drawer = this.context.allDrawers.find(drawer => drawer.id === lastUsedDrawerId);

            if (!posStationId || !this.insideRegister) {
                let optedOutOfPosStationPrompt = !!this.$cookies.get(Meevo.Plugins.DrawerManager.PosStationPrompt.POS_STATION_PROMPT_OPT_OUT_COOKIE);
                if (this.insideRegister && !posStationId && !optedOutOfPosStationPrompt && !this.posStationPromptShownThisPass) {
                    this.posStationPromptShownThisPass = true;
                    return this.promptForPosStation(lastUsedDrawer);
                }

                if (lastUsedDrawer) {
                    return this.context.setSelectedDrawer(lastUsedDrawer, true, Meevo.Model.DrawerSelectionReasonEnum.InitialLoad);
                }

                return this.context.selectSection(DrawerManagerSectionTypeEnum.UnassignedDrawer);
            }

            let posAssignedDrawer: Meevo.Model.Drawer =
                this.context.allDrawers.find(drawer => drawer.posStationId && drawer.posStationId === posStationId);

            if (posAssignedDrawer) {
                // no preference for last used drawer or it is the same drawer as POS assigned drawer
                if (!lastUsedDrawerId || lastUsedDrawer === posAssignedDrawer) {
                    return this.context.setSelectedDrawer(posAssignedDrawer, true, Meevo.Model.DrawerSelectionReasonEnum.InitialLoad);
                }

                return this.setAssignedDrawer(posAssignedDrawer);
            }

            if (lastUsedDrawer) {
                return this.context.setSelectedDrawer(lastUsedDrawer, true, Meevo.Model.DrawerSelectionReasonEnum.InitialLoad);
            }

            return this.context.selectSection(DrawerManagerSectionTypeEnum.UnassignedDrawer);
        }

        // Prompts the user (once per POSStation/opt-out cookie lifecycle) to activate a POS Station before letting them into the Register.
        private promptForPosStation(lastUsedDrawer: Meevo.Model.Drawer) {
            return this.context.getActivePosStations().then((posStations) => {
                if (!posStations || posStations.length < 1) {
                    if (lastUsedDrawer) {
                        return this.context.setSelectedDrawer(lastUsedDrawer, true, Meevo.Model.DrawerSelectionReasonEnum.InitialLoad);
                    }

                    return this.context.selectSection(DrawerManagerSectionTypeEnum.UnassignedDrawer);
                }

                let options = {
                    templateUrl: "app/plugins/drawerManager/posStationPrompt/posStationPrompt.modal.html",
                    controller: "meevo.plugins.drawerManager.posStationPrompt.PosStationPromptModalController",
                    controllerAs: "vm",
                    bindToController: true,
                    clickOutsideToClose: false,
                    locals: {
                        posStations: posStations
                    }
                };

                return this.modalService.showCustom(options).then(() => {
                    // Re-fetch so activePosStationId reflects the station just activated (or stays null on opt-out)
                    return this.context.getAllDrawer().then(() => this.resolveInitialSection());
                });
            });
        }

        private setupEventHandlers() {
            this.$scope.$on(Meevo.Components.Common.Messages.POS_HARDWARE_UPDATED, (event, state, params) => {
                this.context.getReceiptPrinterList();
            });

            this.$scope.$on(Meevo.Components.Common.Messages.SET_PAST_TRANSACTION_DRAWER, (event, state, params) => {
                if (state.name == this.appSettings.ROUTE_NAMES.register) {
                    let drawer: Meevo.Model.Drawer = _(this.context.allDrawers).find(drawer => drawer.id == params.drawerId);
                    this.context.setHistoryDrawer(drawer, params.drawerSessionId);
                }
            });

            this.$scope.$on(Meevo.Components.Common.Messages.SET_CURRENT_DRAWER, (event, state, params) => {
                if (state.name == this.appSettings.ROUTE_NAMES.register) {
                    let drawer: Meevo.Model.Drawer = _(this.context.allDrawers).find(drawer => drawer.id == params.drawerId);
                    this.context.setCurrentDrawer(drawer);
                }
            });            

            this.$scope.$on(Meevo.Components.Common.Messages.DRAWER_MANAGER_SECTION_SWITCHED, (event, state, sectionType, selectedDrawer) => {
                if (state.name == this.appSettings.ROUTE_NAMES.drawerManager && state.instance && this.context !== state.instance) {
                    this.context.selectedDrawer = selectedDrawer;
                    this.context.selectSection(sectionType);
                }
            });

            this.$scope.$on(Meevo.Components.Common.Messages.DRAWER_STATE_CHANGED, (event, state, params) => {
                if (state.name == this.appSettings.ROUTE_NAMES.drawerManager) {
                    this.context.getDrawer(params.selectedDrawerId);
                    this.context.getDrawerSession(params.selectedDrawerId).then(() => {
                        this.context.selectedDrawer.drawerState = this.context.selectedDrawer.drawerSession.drawerState;
                        this.context.checkDrawerState();
                        this.context.getAllDrawer();
                    });
                }
            });

            this.$scope.$on(Meevo.Components.Common.Messages.REFRESH_DRAWER_MANAGER, (event, state) => {
                this.insideRegister = false;
                this.registerContext = undefined;

                if (state.name == this.appSettings.ROUTE_NAMES.drawerManager && state.fromRegister) {
                    this.insideRegister = true;
                    this.registerContext = state.registerContext;

                    if (this.context.selectedDrawer && this.context.selectedDrawer.drawerSession) {
                        this.context.getDrawerSession(this.context.selectedDrawer.id).then(() => {
                            this.context.checkDrawerState();
                        });
                    }
                }
            });
        }

        closeContext() {
            let closeSection = false;

            if (this.context.insideRegister && this.context.selectedDrawer) {
                if (!this.context.isDrawerHistory && this.context.selectedSection.sectionType === DrawerManagerSectionTypeEnum.DrawerHistory) {
                    this.context.checkDrawerState();
                    return;
                } 

                if (this.context.selectedDrawer.drawerState === Meevo.Model.DrawerStateEnum.Close) {
                    if (this.context.isPastTransactionMode()) {
                        closeSection = true;
                    }
                } else {
                    closeSection = true;
                }
            } 

            if (closeSection) {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_DRAWERMANAGER_SECTION, { name: "register" });
            } else {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }
        }

        getNoteByDrawerNoteTypeEnum(type: Meevo.Model.DrawerStateEnum) {
            if (type === Meevo.Model.DrawerStateEnum.Open) {
                return (this.drawerSessionItem.openingNote && this.drawerSessionItem.openingNote.length > 0 ? this.drawerSessionItem.openingNote : null);
            }
            else if (type === Meevo.Model.DrawerStateEnum.Close) {
                return (this.drawerSessionItem.closingNote && this.drawerSessionItem.closingNote.length > 0 ? this.drawerSessionItem.closingNote : null);
            }
            return null;
        }

        cancel = () => {
            this.modalService.hide();
        }
    }

    angular.module("meevo.plugins.drawerManager")
        .controller("meevo.plugins.drawerManager.DrawerManagerController", DrawerManagerController);
}